// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.extension_data {
  /* border: 1px solid red; */
  margin: 22px 35px 0px 24px;
}
.heading {
  font-size: 30px;
  font-weight: 600;
  color: var(--dark2-color);
  padding-bottom: 20px;
  border-bottom: 1px solid var(--text-color);
}
.subheading {
  font-size: 24px;
  font-weight: 500;
  color: var(--dark2-color);
  padding-top: 24px;
  margin-bottom: 20px;
}
.card-container {
  display: flex;
  flex-wrap: wrap;
}

`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Extensions/ManageExtensions.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;AACjB","sourcesContent":[".extension_data {\n  /* border: 1px solid red; */\n  margin: 22px 35px 0px 24px;\n}\n.heading {\n  font-size: 30px;\n  font-weight: 600;\n  color: var(--dark2-color);\n  padding-bottom: 20px;\n  border-bottom: 1px solid var(--text-color);\n}\n.subheading {\n  font-size: 24px;\n  font-weight: 500;\n  color: var(--dark2-color);\n  padding-top: 24px;\n  margin-bottom: 20px;\n}\n.card-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
